<template>
  <div>
        <div class="block-content">
        

        <form class="form-horizontal" action="base_forms_premade.html" method="post" onsubmit="return false;">
            <h3 class="font-w300 push-10">{{ sectionLabelMaintenance[actualLanguage] }}</h3>
          
            <div class="form-group">
              <div class="col-sm-12 col-md-12">
                <div class="col-xs-9">
                    <label for="register4-firstname">{{ labelInterventionTime[actualLanguage] }}</label>
                </div>
                <div class="col-xs-3">
                    <input class="form-control" type="text" v-model="workTime" placeholder="Hr">
                </div>
              </div>
            </div>

            <div class="form-group">
                <div class="col-xs-12">
                    <textarea class="form-control" v-model="description" rows="7" placeholder="Description"></textarea>
                </div>
            </div>

            <div class="form-group">
              <div class="col-sm-12 col-md-12">
                <div>
                    <p><button @click="saveChannelCommentLog()" type="button" class="btn btn-block btn-success" name="button">
                      <spinner size="small" v-if="commentIsSaving"></spinner>
                      <span v-else><i class="fa fa-comment fa-1x push-5-r "></i>{{ buttonLabelSave[actualLanguage] }}</span></button></p>
                </div> 
              </div>
            </div>


          </form>
        </div>




  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'ChannelMaintenanceAddForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      commentIsSaving: false,
      description : '',
      channelIndex : 0,
      workTime : 0,


      actualLanguage : "FR",
      labelFieldEvName: {FR: 'Nom du Véhicule/Borne', EN: 'Vehicle/Charger Name'},
      sectionLabelMaintenance:{FR: "Enregistrement de maintenance d'appareil", EN: 'Records device maintenance'},
      labelInterventionTime:{FR: "Temps d'intervention", EN: 'Intervention time'},
      buttonLabelSave:{FR: "Enregistrer", EN: 'Save'},

      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},

    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  methods: {

    saveChannelCommentLog() {
        this.commentIsSaving = true
        var requestData = { 'postAction':'SaveChannelMaintenanceLog',
                            'bundleId': this.actualBundle.bundle_id,
                            'channelId': this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
                            'localTime':moment().format('Y-MM-DDTHH:mm'),
                            'info':{'postedBy':this.profileData.profileInfo.firstName + " " + this.profileData.profileInfo.lastName,
                                    'postedById':this.profileData.profileId,
                                    'postedByEmail':this.profileData.profileInfo.email,
                                    'description':this.description,
                                    'workTime':this.workTime}
                            }
                            
        this.$store.dispatch('sessionStore/postChannel', requestData)
            .then((response) => {
              //console.log(response.data)
              this.commentIsSaving = false
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                var parameters = {'Parameter':'None'}
                this.$store.dispatch('overlayStore/setParameters',parameters)
                this.$store.dispatch('overlayStore/toggleModal',false)

                }
                else{ window.alert(this.messagePostFail[this.actualLanguage])}
            })       
      
    },
  },


  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    //this.channelIndex = localStorage.actualChannelIndex
    this.channelIndex = this.overlayParameters.channelIndex

  }


}
</script>



// WEBPACK FOOTER //
// ChannelMaintenanceAddForm.vue?6d60fc76